<template>
  <div class="documentos_tudo slot" :class="routeClass">
    <div class="wrap2">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import { useRoute } from 'vue-router';

export default {
  setup() {

    const route = useRoute();

    const routeClass = computed(() => {
      return route.name ? `${route.name.toLowerCase().replace(/\s+/g, '-')}` : '';
    });

    return {
      routeClass
    }
  }
}
</script>

<style scoped>
.wrap2 {
  padding-right: 10%;
  padding-left: 10%;
}

.documentos_tudo {
  max-width: 100rem;
  padding-right: 0px;
  padding-left: 0px;
  padding-top: 0px;
  margin: 0 auto 50px;
  padding-bottom: 50px;
}

.documentos_tudo.slot {
  padding-top: 15px;
}

.documentos_tudo.conselhogeral,
.documentos_tudo.composicao{
  padding-bottom: 0 !important;
}

@media (min-width: 1400px) {
  .wrap2 {
    padding-left: 15%;
    padding-right: 15%;
    max-width: 100%;
    margin: 0;
  }

  .documentos_tudo.slot.reuniao,
  .documentos_tudo.slot.eleicao,
  .documentos_tudo.slot.noticia{
    max-width: 100%;
  }
}

@media (max-width: 767px) {

  .documentos_tudo.composicao{
    margin-bottom: 0 !important;
  }

  .wrap2 {
    padding-right: 5%;
    padding-left: 5%;
  }

  .documentos_tudo, .documentos_tudo.slot {
    padding-top: 0;
  }
}
</style>